import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import errors from "../dashboard/reducers/errorReducer";
import securityAlertsLastMonth from "../dashboard/reducers/securityAlertsLastMonthReducer";
import securityAlertsLastMonthIsLoading from "../dashboard/reducers/securityAlertsLastMonthLoadingReducer";
import securityAlertsLastWeekIsLoading from "../dashboard/reducers/securityAlertsLastWeekLoadingReducer";
import logIncident from "../incidents/incidentReducer";
import incidentSorting from "../incidents/sortIncidentReducer";
import incidentErrors from "../incidents/errorsReducer";
import incidentIsLoading from "../incidents/incidentsIsLoadingReducer";
import isOpenIncidentEmpty from "../incidents/isOpenIncidentEmptyReducer";
import incidentPriorityFilter from "../incidents/incidentsPriorityFilterReducer";
import incidentStatusFilter from "../incidents/incidentsStatusFilterReducer";
import incidentSearchFilter from "../incidents/incidentsSearchFilterReducer";
import incidents from "../dashboard/reducers/incidentsReducer";
import incidentsIsLoading from "../dashboard/reducers/incidentsLoadingReducer";
import securityAlertsLastWeek from "../dashboard/reducers/securityAlertsLastWeekReducer";
import systemStatus from "../dashboard/reducers/systemStatusReducer";
import systemStatusIsLoading from "../dashboard/reducers/systemStatusLoadingReducer";
import deviceGroups from "../dashboard/reducers/deviceGroupsReducer";
import deviceGroupsIsLoading from "../dashboard/reducers/deviceGroupsIsLoadingReducer";
import logsPerDay from "../dashboard/reducers/logsPerDayReducer";
import logsPerDayIsLoading from "../dashboard/reducers/logsPerDayLoadingReducer";
import logSources from "../log-sources/logSourcesReducer";
import logSourceErrors from "../log-sources/errorsReducer";
import selectedFilters from "../log-sources/selectedFiltersReducer";
import logSourcesSorting from "../log-sources/sortLogSourcesReducer";
import logSourcesIsLoading from "../log-sources/logSourcesIsLoadingReducer";
import logSourceFilters from "../log-sources/logSourceFiltersReducer";
import reports from "../reports/reportsReducer";
import reportFilters from "../reports/reportsFilterReducer";
import customerInformation from "../customer-information/CustomerInformationReducer";
import customerInformationError from "../customer-information/customerInformationErrorReducer";
import { reducer as oidcReducer } from "redux-oidc";
import reportHasErrors from "../reports/reportHasErrors";
import reportsIsLoading from "../reports/reportsIsLoadingReducer";
import silentRenew from "../oidc/silentRenewErrorReducer";
import oidcUserActions from "../oidc/oidcUserActionsReducer";
export default combineReducers({
  oidc: oidcReducer,
  routing: routerReducer,
  errors,
  securityAlertsLastMonth,
  securityAlertsLastMonthIsLoading,
  logIncident,
  incidentSorting,
  incidentErrors,
  incidentIsLoading,
  isOpenIncidentEmpty,
  incidents,
  incidentPriorityFilter,
  incidentStatusFilter,
  incidentSearchFilter,
  incidentsIsLoading,
  securityAlertsLastWeek,
  securityAlertsLastWeekIsLoading,
  systemStatus,
  systemStatusIsLoading,
  deviceGroups,
  deviceGroupsIsLoading,
  selectedFilters,
  logsPerDay,
  logsPerDayIsLoading,
  logSources,
  logSourceErrors,
  logSourcesSorting,
  logSourcesIsLoading,
  logSourceFilters,
  reports,
  reportFilters,
  customerInformation,
  customerInformationError,
  reportHasErrors,
  reportsIsLoading,
  silentRenew,
  oidcUserActions,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js